const config: any = {
  rowSelection: false,
  searchMode: "group",
  columns: [
    {
      title: '楼盘编码',
      dataIndex: 'buildingCode',
      fixed: 'left',
      width: 200,
      render: 'clueIdRender',
    },
    {
      title: '楼盘名称',
      dataIndex: 'name',
      width: 200,
    },
    {
      title: '省',
      dataIndex: 'provinceName',
      width: 120,
    },
    {
      title: '市',
      dataIndex: 'cityName',
      width: 120,
    },
    {
      title: '区',
      dataIndex: 'countyName',
      width: 120,
    },
    {
      title: '远程费标准',
      dataIndex: 'remoteFeeName',
      width: 120,
    },
    {
      title: '是否重点楼盘',
      dataIndex: 'emphasisFlag',
      render: 'emphasisFlag',
      width: 120,
    },
    {
      title: '楼盘属性',
      dataIndex: 'financialAttr',
      render: 'financialAttrRender',
      width: 100,
    },
    {
      title: '立项期楼盘状态',
      dataIndex: 'constructionStatName',
      width: 130,
    },
    {
      title: '签单目标(万元)',
      dataIndex: 'signingTarget',
      width: 150,
    },
    {
      title: '门店距离(KM)',
      dataIndex: 'companyDistance',
      width: 150,
    },
    {
      title: '楼盘所属区域',
      dataIndex: 'buildingAreaName',
      width: 120,
    },
    {
      title: '楼盘均价',
      dataIndex: 'price',
      width: 100,
    },
    {
      title: '交房时间',
      dataIndex: 'handoverDate',
      itemType: 'date',
      width: 180,
    },
    {
      title: '分公司',
      dataIndex: 'companyName',
      width: 180,
    },
    // {
    //   title: '远程费金额',
    //   dataIndex: 'remoteFee',
    //   width: 130,
    // },
    {
      title: '楼盘状态',
      dataIndex: 'statusName',
      width: 100,
    },
    {
      title: '楼盘面积区间',
      dataIndex: 'areaRange',
      width: 120,
    },
    {
      title: '楼盘户数',
      dataIndex: 'houseNumber',
      width: 120,
    },
    {
      title: '开发商',
      dataIndex: 'estateDeveloperName',
      width: 240,
    },
    {
      title: '楼盘详细地址',
      dataIndex: 'address',
      width: 200,
      ellipsis: true,
    },
    {
      title: '主力面积',
      dataIndex: 'mainArea',
      width: 100,
    },
    // {
    //   title: '软装远程费',
    //   dataIndex: 'softRemoteFee',
    //   width: 130,
    // },
    {
      title: '开发部门',
      dataIndex: 'developDeptName',
      width: 100,
    },
    {
      title: '开发周期',
      dataIndex: 'developTotalDates',
      width: 120,
    },
    {
      title: '开发开始时间',
      dataIndex: 'developStartDate',
      itemType: 'date',
      width: 120,
    },
    {
      title: '开发结束时间',
      dataIndex: 'developEndDate',
      itemType: 'date',
      width: 120,
    },
    {
      title: '小区深耕费用计划',
      dataIndex: 'plannedCosts',
      width: 160,
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 160,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  searchFormConfig:false,
  search: [
    {
      name: 'orgId',
      label: '分公司',
      itemType: 'select',
      data: 'companyList',
      labelKey: 'name',
      key: 'id',
      events: ['onChange:onCompanyChange']
    },
    {
      name: 'buildingAreaId',
      label: '楼盘区域',
      data: 'buildingId',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      notFoundContent: '请选择公司或无匹配数据',
    },
    {
      name: 'buildingCode',
      label: '楼盘编码',
    },
    {
      name: 'nameLike',
      label: '楼盘名称',
    },
    {
      name: 'emphasisFlag',
      label: '是否重点楼盘',
      itemType: 'select',
      data: 'statusOptions',
    },
    {
      name: 'remoteFeeKeyFlag',
      label: '是否配置远程费',
      itemType: 'select',
      data: 'enabledOptions',
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      // auth: 'AddBuildingButton',
      events: ['onClick:onAdd'],
    },
    {
      label: '下载批量添加模板',
      events: ['onClick:onExportTemplate'],
      // auth: 'BuildingDownloadTemplate',
    },
    {
      label: '批量导入',
      // auth: 'ImportBuilding',
      render: 'buildingInfoExcel',
    },
    // {
    //   label: '完工地图',
    //   events: ['onClick:completeArea'],
    // },
  ],
}
export default config
